"use strict";

require("core-js/modules/es6.number.is-nan.js");

require("core-js/modules/es6.number.constructor.js");

module.exports = function () {
  var numberIsNaN = Number.isNaN;
  if (typeof numberIsNaN !== "function") return false;
  return !numberIsNaN({}) && numberIsNaN(NaN) && !numberIsNaN(34);
};